import { render, staticRenderFns } from "./ChoiceCreator.vue?vue&type=template&id=827e61e4&scoped=true&"
import script from "./ChoiceCreator.vue?vue&type=script&lang=ts&"
export * from "./ChoiceCreator.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceCreator.vue?vue&type=style&index=0&id=827e61e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827e61e4",
  null
  
)

export default component.exports